export const apenasDigitos = (valor) => String(valor || '').replace(/\D/g, '')

export const apenasAlfanumerico = (valor) => String(valor || '').toUpperCase().replace(/[^0-9A-Z]/g, '')

export const normalizarCpf = (valor) => apenasDigitos(valor).slice(0, 11)

export const normalizarCnpjAlfanumerico = (valor) => {
	const texto = apenasAlfanumerico(valor)
	const corpo = texto.slice(0, 12)
	const digitosVerificadores = texto.slice(12).replace(/\D/g, '').slice(0, 2)
	return `${corpo}${digitosVerificadores}`.slice(0, 14)
}

export const documentoTemLetras = (valor) => /[A-Z]/.test(apenasAlfanumerico(valor))

export const documentoEhCnpj = (valor, tipoPessoa = '') => {
	if (tipoPessoa === 'JURIDICA') return true
	if (tipoPessoa === 'FISICA') return false
	const documento = apenasAlfanumerico(valor)
	return documentoTemLetras(documento) || documento.length > 11
}

export const normalizarCpfCnpj = (valor, tipoPessoa = '') => {
	return documentoEhCnpj(valor, tipoPessoa) ? normalizarCnpjAlfanumerico(valor) : normalizarCpf(valor)
}

export const formatarCpf = (valor) => {
	const n = normalizarCpf(valor)
	if (n.length <= 3) return n
	if (n.length <= 6) return `${n.slice(0, 3)}.${n.slice(3)}`
	if (n.length <= 9) return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`
	return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9, 11)}`
}

export const formatarCnpjAlfanumerico = (valor) => {
	const n = normalizarCnpjAlfanumerico(valor)
	if (n.length <= 2) return n
	if (n.length <= 5) return `${n.slice(0, 2)}.${n.slice(2)}`
	if (n.length <= 8) return `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5)}`
	if (n.length <= 12) return `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8)}`
	return `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8, 12)}-${n.slice(12, 14)}`
}

export const formatarCpfCnpj = (valor, tipoPessoa = '') => {
	return documentoEhCnpj(valor, tipoPessoa) ? formatarCnpjAlfanumerico(valor) : formatarCpf(valor)
}

export const valorDocumentoCnpjAlfanumerico = (char) => {
	return char.charCodeAt(0) - 48
}

const calcularDigitoCnpj = (base, pesos) => {
	const soma = base.split('').reduce((total, char, index) => total + (valorDocumentoCnpjAlfanumerico(char) * pesos[index]), 0)
	const resto = soma % 11
	return resto < 2 ? 0 : 11 - resto
}

export const validarCpf = (cpf) => {
	const n = normalizarCpf(cpf)
	if (n.length !== 11 || /^(\d)\1+$/.test(n)) return false

	let soma = 0
	for (let i = 0; i < 9; i += 1) soma += Number(n.charAt(i)) * (10 - i)
	let digito = 11 - (soma % 11)
	if (digito === 10 || digito === 11) digito = 0
	if (digito !== Number(n.charAt(9))) return false

	soma = 0
	for (let i = 0; i < 10; i += 1) soma += Number(n.charAt(i)) * (11 - i)
	digito = 11 - (soma % 11)
	if (digito === 10 || digito === 11) digito = 0
	return digito === Number(n.charAt(10))
}

export const validarCnpjAlfanumerico = (cnpj) => {
	const n = normalizarCnpjAlfanumerico(cnpj)
	if (n.length !== 14 || !/^[0-9A-Z]{12}[0-9]{2}$/.test(n)) return false
	if (/^0{14}$/.test(n) || /^(\d)\1{13}$/.test(n)) return false

	const pesosPrimeiroDigito = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
	const pesosSegundoDigito = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
	const primeiroDigito = calcularDigitoCnpj(n.slice(0, 12), pesosPrimeiroDigito)
	const segundoDigito = calcularDigitoCnpj(`${n.slice(0, 12)}${primeiroDigito}`, pesosSegundoDigito)

	return n.slice(12) === `${primeiroDigito}${segundoDigito}`
}
